import { Link, useSearchParams } from '@remix-run/react';
import { useTranslation } from 'react-i18next';
import { languages } from '#common/i18n/config';
import { useTranslatedPath, type PathTranslationOptions } from '#common/utils/i18n';

interface Props {
    baseUrl: string;
    pathTranslationOptions?: PathTranslationOptions;
    className?: string;
}

export default function LanguagePicker({ baseUrl, pathTranslationOptions, className }: Props) {
    const [ searchParams ] = useSearchParams();
    const { i18n } = useTranslation();
    const translatePath = useTranslatedPath(pathTranslationOptions);
    const entries = Object.entries(languages);
    const activeLanguage = (i18n.resolvedLanguage ?? i18n.language).split('-')[0];

    return (
        <div className={className}>
            {entries.map(([ lang, label ], index) => {
                const separator = baseUrl.includes('?') ? '&' : '?';
                const queryString = searchParams.toString();
                const url = queryString ? `${baseUrl}${separator}${queryString}` : baseUrl;
                return (
                    <span key={lang}>
                        {index > 0 && ' | '}
                        <Link
                            to={translatePath(url, lang)}
                            className='text-inherit hover:opacity-75'
                            aria-current={lang === activeLanguage ? 'page' : undefined}
                        >
                            {label}
                        </Link>
                    </span>
                );
            })}
        </div>
    );
}
